import VuexPersistence from 'vuex-persist'
import Cookies from 'js-cookie'
// import Base64 from './Base64'

// const ECODE_KEY = process.env.VUE_APP_ENCODE_KEY || ''

export const storageUser = new VuexPersistence({
  key: 'praivech_admin',
  restoreState: (key) => {
    let cookieData = Cookies.get(key) || ''
    if (cookieData && typeof cookieData === 'string') {
      cookieData = JSON.parse(cookieData)
    }
    return {
      User: {
        ...cookieData
      }
    }
  },
  saveState: (key, state) => {
    const stateUser = state?.User
    const cookieData = {
      userId: stateUser.userId || null,
      firstName: stateUser.firstName || null,
      lastName: stateUser.lastName || null,
      email: stateUser.email || null,
      tokenExpire: stateUser?.tokenExpire || null,
      accessToken: stateUser?.accessToken || null
    }
    const expires = cookieData.tokenExpire ? new Date(cookieData.tokenExpire) : 6
    Cookies.set(key, JSON.stringify(cookieData), {
      expires
    })
  },
  modules: ['User']
})

export const storageClinic = new VuexPersistence({
  key: 'praivech_clinic',
  restoreState: (key) => {
    let cookieData = Cookies.get(key) || ''
    if (cookieData && typeof cookieData === 'string') {
      cookieData = JSON.parse(cookieData)
    }
    return {
      Clinic: {
        ...cookieData
      }
    }
  },
  saveState: (key, state) => {
    const stateClinic = state?.Clinic
    const cookieData = {
      userId: stateClinic.userId || null,
      firstName: stateClinic.firstName || null,
      lastName: stateClinic.lastName || null,
      imageUrl: stateClinic.imageUrl || null,
      imageUserUrl: stateClinic.imageUserUrl || null,
      email: stateClinic.email || null,
      address: stateClinic.address || null,
      role: stateClinic.role || null,
      clinicId: stateClinic.clinicId || null,
      clinicName: stateClinic.clinicName || null,
      tokenExpire: stateClinic?.tokenExpire || null,
      accessToken: stateClinic?.accessToken || null,
      vatType: stateClinic?.vatType || null
    }
    const expires = cookieData.tokenExpire ? new Date(cookieData.tokenExpire) : 6
    Cookies.set(key, JSON.stringify(cookieData), {
      expires
    })
  },
  modules: ['Clinic']
})

export const storageBranch = new VuexPersistence({
  key: 'praivech_branch',
  restoreState: (key) => {
    let cookieData = Cookies.get(key) || ''
    if (cookieData && typeof cookieData === 'string') {
      cookieData = JSON.parse(cookieData)
    }
    return {
      Branch: {
        ...cookieData
      }
    }
  },
  saveState: (key, state) => {
    const stateBranch = state?.Branch
    const cookieData = {
      userId: stateBranch.userId || null,
      fee: stateBranch.fee || null,
      doctorId: stateBranch.doctorId || null,
      typeDoctorId: stateBranch.typeDoctorId || null,
      username: stateBranch.username || null,
      firstName: stateBranch.firstName || null,
      lastName: stateBranch.lastName || null,
      imageUserUrl: stateBranch.imageUserUrl || null,
      email: stateBranch.email || null,
      role: stateBranch.role || null,
      clinicId: stateBranch.clinicId || null,
      clinicName: stateBranch.clinicName || null,
      branchId: stateBranch.branchId || null,
      branchName: stateBranch.clinicName || null,
      tokenExpire: stateBranch?.tokenExpire || null,
      accessToken: stateBranch?.accessToken || null
    }
    const expires = cookieData.tokenExpire ? new Date(cookieData.tokenExpire) : 6
    Cookies.set(key, JSON.stringify(cookieData), {
      expires
    })
  },
  modules: ['Branch']
})

export default {
  storageUser,
  storageClinic,
  storageBranch
}
